const model = {
  username: {
    name: "Имя пользователя",
    sex: 0,
    required: true,
    checkLength: true,
    min: 3,
    max: 30,
    regexp: /^[a-z\d](?:[a-z\d]|[-_](?=[a-z\d])){2,30}$/i
  },
  password: {
    name: "Пароль",
    sex: 1,
    required: true,
    checkLength: true,
    min: 6,
    max: 32
  }
};

module.exports = model;
